import { makeStyles, tokens } from "@fluentui/react-components";
import React from "react";
import { Link } from "react-router-dom";
import PageEnum from "../../../../enum/PageEnum";

type IFlightNumberCellLinkProps = {
  airport: string;
  flightNumber: string;
  docId: string;
  openInNewTab?: boolean;
};

const FlightNumberCellLink: React.FC<IFlightNumberCellLinkProps> = ({
  airport,
  flightNumber,
  docId,
  openInNewTab = true,
}) => {
  const classes = useStyles();

  const displayText = flightNumber.trim() || "";

  if (!airport || !docId || !flightNumber) {
    return <span>{displayText}</span>;
  }

  const title = `${displayText}${openInNewTab ? " in a new tab" : ""}`;

  return (
    <Link
      to={`/${PageEnum.PageUrl.SingleFlightView}?docId=${encodeURIComponent(
        docId
      )}&airport=${encodeURIComponent(airport)}`}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.link}
      title={title}
    >
      {displayText}
    </Link>
  );
};

export default FlightNumberCellLink;

const useStyles = makeStyles({
  link: {
    color: tokens.colorBrandForegroundLink,
    cursor: "pointer",
    flightNumberDecoration: "none",

    ":hover": {
      flightNumberDecoration: "underline",
      color: tokens.colorBrandForegroundLinkHover,
    },

    ":visited": {
      color: tokens.colorPalettePurpleForeground2,
    },
  },
});
